/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_SessionInputs */

const en_audit_session = /** @type {(inputs: Audit_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit Session`)
};

const es_audit_session = /** @type {(inputs: Audit_SessionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesion de Auditoria`)
};

/**
* | output |
* | --- |
* | "Audit Session" |
*
* @param {Audit_SessionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_session = /** @type {((inputs?: Audit_SessionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_SessionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_session(inputs)
	return es_audit_session(inputs)
});